import { CustomElement } from '@aurelia/runtime-html';
export const name = "switch-component";
export const template = "<div class=\"flex items-center gap-3 font-raleway\">\n  <label class=\" peer\n      toggle\n      ${checked\n        ? disabled\n          ? 'toggle-checked-disabled'\n          : 'toggle-checked'\n        : disabled\n          ? 'toggle-unchecked-disabled'\n          : 'toggle-unchecked'}\n    \">\n    <input id=\"${id}\" type=\"checkbox\" class=\"toggle-input\" checked.bind=\"checked\" disabled.bind=\"disabled\" />\n    <span class=\"toggle-thumb\"></span>\n  </label>\n\n  <label for=\"${id}\"\n    class=\"text-gray-900 dark:text-gray-50 ${checked ? 'text-base-bold' : 'text-base-medium'} ${disabled ? '!text-gray-400 dark:!text-gray-400' : ''}\">${label}</label>\n</div>";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
